import { Waypoint } from "vue-waypoint";

export default {
  name: "VenueLabs",
  props: {
    data: Object,
  },
  components: {
    Waypoint,
  },
  created() {},
};
